export default "__VITE_PUBLIC_ASSET__ec836f4c__"